import React from 'react';
import PropTypes from 'prop-types';
import ShowHide from '@cotyorg/ccx-utils/js/components/ShowHide';
import CountriesWrapper from './CountriesWrapper';

const CountrySelector = ({
  regions,
  gridPadding,
  isCountrySelectorVisible = false,
  isServedFromLegacySite,
}) => (
  <div className="country-selector">
    <ShowHide
      isOpen={isCountrySelectorVisible}
      noTransitionClass="accordion__item-body--no-transition"
      extraClass="countries-wrapper"
      scrollTo
    >
      <CountriesWrapper
        regions={regions}
        gridPadding={gridPadding}
        isServedFromLegacySite={isServedFromLegacySite}
      />
    </ShowHide>
  </div>
);

CountrySelector.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      langs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })),
    })),
  })).isRequired,
  isCountrySelectorVisible: PropTypes.bool,
  gridPadding: PropTypes.bool,
  isServedFromLegacySite: PropTypes.bool,
};

export default CountrySelector;
